// text for FormSelect, label for search chip

const tbIntervalOptions = [
  { text: 'Show All', value: '', label: 'Show All' },
  { text: '6 Months', value: '0.5', label: 'TB Interval - 6 Months' },
  { text: '1 Year', value: '1', label: 'TB Interval - 1 Year' },
  { text: '4 Years', value: '4', label: 'TB Interval - 4 Years' }
]

export default tbIntervalOptions
